import React from 'react';

function RadioButtons(props) {
    const {
        options,
        required = false,
        name,
        onChange = () => {}
    } = props;

    const handleChange = (event) => {
        onChange(event.target.value);
    };

    const handleKeyDown = (event, inputRef) => {
        if (event.key === "Enter" || event.keyCode === 13) {
            inputRef.current?.click();
        }
    };

    return (
        <div className="radio-buttons">
            {options ?
                options.map((item, index) => {
                    const inputRef = React.createRef();
                    return (
                        <label className="radio-button" key={index} tabIndex={0} onKeyDown={(e) => handleKeyDown(e, inputRef)}>
                            <input
                                ref={inputRef}
                                name={name}
                                type="radio"
                                value={item}
                                required={required}
                                onChange={handleChange}
                            />
                            <span className="radio-button__check"></span>
                            <span className="radio-button__label">{item}</span>
                        </label>
                    );
                })
            : ""}
        </div>
    );
}

export default RadioButtons;
